import { Dispatch } from "redux";
import { errorHandler } from "../../helpers/Functions";
import { Pagination } from "../../Interfaces/Interfaces";
import CoordinatorService from "../../services/CoordinatorService";
import UserService from "../../services/UserService";

export const getPagedCoordinators = (data: Pagination) => {
  const api = new CoordinatorService().getPagedCoordinators(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: 'COORDINATORS',
            payload: res,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: 'Network request failed',
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

export const getCoordinatorCashoutAccount = (id: string) => {
  const api = new CoordinatorService().getCashoutAccount(id);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: 'CASHOUT',
            payload: res.result,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              successful: false,
              message: errorHandler(res)
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

export const queryPagedCoordinators = (data: Pagination) => {
  const api = new CoordinatorService().queryPagedCoordinators(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: 'COORDINATORS',
            payload: res,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: 'Network request failed',
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

export const getCurrentUser = (token: string) => {
  const api = new UserService().getCoordinatorUser(token);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {

          // set authentication to true
          sessionStorage.setItem('auth', 'true');

          let user = res.result;
          sessionStorage.setItem('coordinatorType', JSON.stringify(user.coordinatorTypeId));
          dispatch({
            type: "COORDINATOR_TYPE",
            payload: user.coordinatorTypeId
          })

          dispatch({
            type: 'USER',
            payload: res.result,
          });

          if (!res.result.passwordChanged) {
            localStorage.setItem("passwordChanged", "false")
            window.location.pathname = '/account/update-password';
          } else {
            // window.location.pathname = '/dashboard';

            dispatch({
              type: 'ALERT',
              payload: {
                successful: true,
                message: 'Logged in'
              }
            })
          }

        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: res.message,
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};
export const withdrawToBankCoordinator = (data: any) => {
  const api = new CoordinatorService().withdrawBankCoordinator(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: 'CASHOUT',
            payload: res.result,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              successful: false,
              message: errorHandler(res)
            }
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};
export const getCoordinatorCommissions = (data: Pagination) => {
  const api = new CoordinatorService().getCoordinatorCommissions(data);
  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {

          dispatch({
            type: 'COMMISSIONS',
            payload: res,
          });

        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};
export const withdrawWalletCoordinator = (data: any) => {
  const api = new CoordinatorService().withdrawWalletCoordinator(data);

  return (dispatch: any) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: 'ALERT',
            payload: {
              message: 'Successful',
              successful: true,
            },
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              successful: false,
              message: errorHandler(res)
            }
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

export const queryCoordinatorCommissions = (data: Pagination) => {
  const api = new CoordinatorService().queryCoordinatorCommissions(data);
  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {

          dispatch({
            type: 'COMMISSIONS',
            payload: res,
          });

        } else {

          dispatch({
            type: 'ALERT',
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};


export const getAdminUser = (token: string) => {
  const api = new UserService().getCoordinatorUser(token);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {

          // set authentication to true
          sessionStorage.setItem('auth', 'true');

          let user = res.result;
          sessionStorage.setItem('coordinatorType', JSON.stringify(user.coordinatorTypeId));
          dispatch({
            type: "COORDINATOR_TYPE",
            payload: user.coordinatorTypeId
          })

          dispatch({
            type: 'USER',
            payload: res.result,
          });

        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: res.message,
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

export const createTransactionPIN = (data: any) => {
  const api = new CoordinatorService().createTransactionPIN(data);
  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {

          dispatch({
            type: 'ALERT',
            payload: {
              message: 'Successful',
              successful: true,
            },
          });

        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

export const updateTransactionPIN = (data: Pagination) => {
  const api = new CoordinatorService().updateTransactionPIN(data);
  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {

          dispatch({
            type: 'ALERT',
            payload: {
              message: 'Successful',
              successful: true,
            },
          });

        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

export const resetTransactionPIN = (data: any) => {
  const api = new CoordinatorService().resetTransactionPIN(data);
  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {

          dispatch({
            type: 'ALERT',
            payload: {
              message: 'Successful',
              successful: true,
            },
          });

        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

export const createCashoutAccount = (data: any) => {
  const api = new CoordinatorService().createCashoutAccount(data);
  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {

          dispatch({
            type: 'ALERT',
            payload: {
              message: 'Successful',
              successful: true,
            },
          });

        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};


export const getCoordinatorDashboard = () => {
  const api = new CoordinatorService().getCoordinatorDashboard();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {

          dispatch({
            type: 'DASHBOARD',
            payload: res.result,
          });

        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};
export const getCoordinatorTransactionDashboard = (data: any) => {
  const api = new CoordinatorService().getcoordinatordashboard(data);

  return (dispatch: Dispatch) => {

    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: 'TRANSACTION_DASHBOARD',
            payload: res.result,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              successful: false,
              message: errorHandler(res)
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false
        });

      });
  };
};
export const getCoordinatorAgentsDashboard = (data: any) => {
  const api = new CoordinatorService().getcoordinatordashboardAgents(data);

  return (dispatch: Dispatch) => {

    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: 'AGENT_DASHBOARD',
            payload: res.result,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              successful: false,
              message: errorHandler(res)
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false
        });

      });
  };
};
export const getCoordinatorEarningsDashboard = (data: any) => {
  const api = new CoordinatorService().getcoordinatordashboardEarnings(data);

  return (dispatch: Dispatch) => {

    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: 'EARNING_DASHBOARD',
            payload: res.result,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              successful: false,
              message: errorHandler(res)
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false
        });

      });
  };
};
export const getCoordinatorPerformanceTarget = (data: any) => {
  const api = new CoordinatorService().getcoordinatorPerformanceTerget(data);

  return (dispatch: Dispatch) => {
    console.log(data)
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: 'TRANSACTION_TARGET',
            payload: res.result,
          });
        } else {
          // dispatch({
          //   type: "ALERT",
          //   payload: {
          //     successful: false,
          //     message: errorHandler(res),
          //   },
          // });
          dispatch({
            type: "TRANSACTION_TARGET",
            payload: {},
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

        dispatch({
          type: "INTERNAL_LOADER",
          payload: false
        });

      });
  };
};